import { FinancialAccountFragment } from "@/__generated__/graphql";
import { DataViewThreadActions } from "@/components/organisms/DataView/DataViewThreadActions";
import { type TableDialogSelectionActionsProps } from "@/components/organisms/Table/TableDialog";
import { ThreadMessageContextItemType } from "@/state/@types";

export function financialAccountToThreadContext(
  account: FinancialAccountFragment,
): ThreadMessageContextItemType {
  return {
    id: account.id,
    identifier: account.identifier,
    name: account.name || account.officialName || "Untitled",
    typename: "FinancialAccountObject",
  };
}

export const FINANCIAL_ACCOUNT_THREAD_MENU_OPTIONS = [
  { id: "matching-transactions", message: "Find transactions" },
  { id: "reconcile", message: "Reconcile" },
] as const;

type FinancialAccountsViewThreadActionsProps =
  TableDialogSelectionActionsProps & {
    onPrepareThread: (checkedRowIds: string[], draft?: string) => void;
  };

export function FinancialAccountsViewThreadActions({
  menuOptions = FINANCIAL_ACCOUNT_THREAD_MENU_OPTIONS,
  ...props
}: FinancialAccountsViewThreadActionsProps & {
  menuOptions?: typeof FINANCIAL_ACCOUNT_THREAD_MENU_OPTIONS;
}) {
  return <DataViewThreadActions {...props} menuOptions={[...menuOptions]} />;
}
